import React, { useEffect, useMemo, useRef, useState } from 'react'

// 값을 골라 거르는 드롭다운. 계정과목 백여 개, 거래처 수백 개를 한 줄짜리 select 로
// 훑게 하면 찾지 못한다. 검색 한 칸과 체크박스를 함께 둔다.
//
// 아무것도 안 고른 상태가 '전체'다. 빈 선택을 '아무것도 안 보임'으로 두면 화면을
// 열자마자 표가 비어 사람이 당황한다.
export default function FilterPopover({ label, options, value, onChange, width = 260 }) {
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const box = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const 밖 = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false) }
    const esc = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', 밖)
    document.addEventListener('keydown', esc)
    return () => {
      document.removeEventListener('mousedown', 밖)
      document.removeEventListener('keydown', esc)
    }
  }, [open])

  const 값 = (o) => String(o?.value ?? o)
  const 이름 = (o) => String(o?.label ?? o)
  const 보일것 = useMemo(() => {
    const 말 = q.trim()
    if (!말) return options
    return options.filter((o) => (이름(o) + ' ' + (o?.sub ?? '')).includes(말))
  }, [options, q])

  const 켜기 = (v) => {
    const n = new Set(value)
    if (n.has(v)) n.delete(v)
    else n.add(v)
    onChange(n)
  }

  return (
    <div className="fpop" ref={box}>
      <button type="button" className={'fpop-btn' + (value.size ? ' on' : '')}
        onClick={() => setOpen(!open)}>
        {label}{value.size ? <span className="fpop-n">{value.size}</span> : null}
        <span className="fpop-caret">▾</span>
      </button>
      {open && (
        <div className="fpop-panel" style={{ width }}>
          <input autoFocus className="fpop-q" placeholder={`${label} 검색…`}
            value={q} onChange={(e) => setQ(e.target.value)} />
          <div className="fpop-list">
            {보일것.length === 0 && <div className="muted fpop-empty">해당하는 값이 없습니다</div>}
            {보일것.map((o) => (
              <label key={값(o)} className="fpop-item">
                <input type="checkbox" checked={value.has(값(o))} onChange={() => 켜기(값(o))} />
                <span className="fpop-name">{이름(o)}</span>
                {o?.sub ? <span className="muted fpop-sub">{o.sub}</span> : null}
              </label>
            ))}
          </div>
          <div className="fpop-foot">
            <span className="muted">{value.size ? `${value.size}개 선택` : '전체'}</span>
            <button type="button" className="btn secondary tiny"
              onClick={() => onChange(new Set(보일것.map(값)))}>보이는 것 모두</button>
            <button type="button" className="btn secondary tiny"
              onClick={() => onChange(new Set())}>해제</button>
          </div>
        </div>
      )}
    </div>
  )
}
